import React from 'react'
import { observer } from 'mobx-react'
import PortAttributeInfo from './PortAttributeInfo'
import Spinner from '../misc/Spinner'

function PortInfo ({atts = null, showall = false}) {
  const loading = <tr>
    <td><Spinner/></td>
  </tr>

  return (
    <table>
      <tbody>
      {atts === null ? loading : Object.keys(atts).map((key, index) => atts[key].important !== true && showall !== true ? null :
        <PortAttributeInfo key={key} item={atts[key]} showall={showall}/>)}
      </tbody>
    </table>
  )
}

export default observer(PortInfo)